import { Fund } from "src/app/domain/fund-performance/dto/Fund";
import { Rows } from "../../interfaces";
import { getHeaders } from "./headers";
import { centerNoBold, leftBold } from "src/app/util/excelStyles";
import { withCellStyles } from "../../utils";

export const getPreparedData = (data: Fund[]): Rows => {
  const newData: Rows = [];
  const headers = getHeaders();
  newData.push(headers);
  const funds = data.filter((f) => !f.spv);
  if (funds.length) {
    newData.push([withCellStyles('Funds', leftBold)]);
    const fundsRows = getManyRows(funds);
    newData.push(...fundsRows);
  }
  const spvs = data.filter((f) => f.spv);
  if (spvs.length) {
    newData.push([withCellStyles('SPVs', leftBold)]);
    const spvsRows = getManyRows(spvs);
    newData.push(...spvsRows);
  }
  return newData;
};

export const getManyRows = (data: Fund[]): Rows => {
  const rows: Rows = [];
  const headers = getHeaders();
  const mappedToHeaders = data.map((fp) => getNewMapping(fp));
  for (const mapped of mappedToHeaders) {
    const row = [];
    for (const header of headers) {
      row.push(withCellStyles(mapped[header], centerNoBold));
    }
    rows.push(row);
  }
  return rows;
};

export const getNewMapping = (fund: Fund): object => {
  const body = {
    Fund: fund.name,
    ID: fund.fundId,
    'Registration state': fund.registration,
    'Registration number': fund.registrationNumber,
    'Registration date': fund.registrationDate?.toString(),
    'Initial closing': fund.finalClosing?.toString(),
    'Final closing': fund.finalClosing,
    'Investment period': fund.investmentPeriod,
    "Fund's term": fund.fundTerm,
    'Management company': fund.managementCompany?.name,
  };
  return body;
};
